((angular) => {
  'use strict';

  angular
    .module('Pages')
    .controller('Pages.archivesCtrl', [
      '$scope',
      '$timeout',
      '$q',
      '$rootScope',
      'Loader',
      'Toast',
      'AuthService',
      'ParticipantService',
      'EventService',
      'CompanyService',
      archivesCtrl,
    ]);

  function archivesCtrl(
    $scope,
    $timeout,
    $q,
    $rootScope,
    Loader,
    Toast,
    authService,
    participantService,
    EventService,
    CompanyService
  ) {
    this.user = authService.getTokenData();
    this.participant;
    this.activity_corporativa = undefined;
    this.activity_complementar = undefined;
    this.activity_premium = undefined;
    this.activity_marketing = undefined;
    this.events;
    this.isAssociado = this.user.company.company_type.name === 'ASSOCIADO';
    this.banner;
    this.company_types;
    this.sponsor_types;

    // console.log(this.user.company.type_id);
    if (this.user.company.type_id === null) {
      this.user.company.type_id = this.getNotInformmed();
    }

    CompanyService.listCompanyTypes().then((companyTypes) => {
      this.company_types = companyTypes;
    });

    EventService.list(this.user.cpf).then((events) => {
      this.events = events;
      this.events.forEach((event) => {
        event.activity_corporativa = event.activity.filter((activity) => {
          return activity.type === 'main' && activity.attachments.length > 0;
        });
        event.activity_complementar = event.activity.filter((activity) => {
          return (
            activity.type === 'additional' && activity.attachments.length > 0
          );
        });
        event.activity_premium = event.activity.filter((activity) => {
          return activity.type === 'premium' && activity.attachments.length > 0;
        });

        event.activity_marketing = event.activity.filter((activity) => {
          if (
            this.isAssociado &&
            this.user.company.id === activity.company_id
          ) {
            return (
              activity.type === 'marketing_activity' &&
              activity.attachments.length > 0
            );
          } else if (!this.isAssociado) {
            return (
              activity.type === 'marketing_activity' &&
              activity.attachments.length > 0
            );
          }
        });
        this.verifyShow(event.activity_corporativa);
        this.verifyShow(event.activity_complementar);
        this.verifyShow(event.activity_premium);
        this.verifyShow(event.activity_marketing);
      });
      this.banner = this.events[0].assets
        .filter((a) => a.type === 'banner')
        .map((a) => a.path)[0];
      this.verifyMessage();
    });

    this.verifyShow = (activityList) => {
      activityList.forEach((activity) => {
        activity.attachments.forEach((att) => {
          att.attachmentCompanyTypes_activityId.forEach((attCompany) => {
            att.show = false;
            // console.log(this.user.company.type_id);

            // console.log(attCompany.company_type_id);
            if (this.user.company.type_id === attCompany.company_type_id) {
              att.show = true;
            } else {
              att.show = false;
            }
          });
        });
        activity.attachments = activity.attachments.filter((att) => {
          return att.show === true;
        });
      });
    };

    this.getNotInformmed = () => {
      const verifyType = this.company_types.filter((ct) => {
        return ct.name === 'NÃO INFORMADO';
      });
      return verifyType[0].id;
    };

    this.verifyEvents = (event) => {
      const corp = event.activity_corporativa.filter((corp) => {
        return corp.attachments.length > 0;
      });

      const comp = event.activity_complementar.filter((comp) => {
        return comp.attachments.length > 0;
      });

      const mark = event.activity_marketing.filter((mark) => {
        return mark.attachments.length > 0;
      });

      const premmy = event.activity_premium.filter((premmy) => {
        return premmy.attachments.length > 0;
      });

      this.showList =
        corp.length > 0 ||
        comp.length > 0 ||
        mark.length > 0 ||
        premmy.length > 0;

      return this.showList;
    };

    this.verifyMessage = () => {
      this.showMessage = true;
      this.events.forEach((event) => {
        const corp = event.activity_corporativa.filter((corp) => {
          return corp.attachments.length > 0;
        });

        const comp = event.activity_complementar.filter((comp) => {
          return comp.attachments.length > 0;
        });

        const mark = event.activity_marketing.filter((mark) => {
          return mark.attachments.length > 0;
        });

        const premmy = event.activity_premium.filter((premmy) => {
          return premmy.attachments.length > 0;
        });

        if (
          corp.length > 0 ||
          comp.length > 0 ||
          mark.length > 0 ||
          premmy.length > 0
        ) {
          this.showMessage = false;
          return false;
        }
      });
    };
  }
})(angular);
